/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvestmentTradeEvent} from '../api'

 export const useQueryGetInvestmentTradeEvent = createReactQueryHook('getInvestmentTradeEvent', getInvestmentTradeEvent)
